import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setCurrentPage } from 'store/ResponseTemplate/actions';
// third-party
import { QuestionRegistrySideBars } from '../constants';
import PremiumPlanWrapper from 'Components/PremiumPlanWrapper';
import { FREEMIUM_LIMITATION } from 'helper/checkPlan.helper';
import QuestionRegistryCard from '../QuestionRegistryCard';
import ImportQuestionCSVCard from '../ImportQuestionCSVCard';
import FreemiumQuestionCard from '../FreemiumQuestionCard';
import NewQuestionCard from '../NewQuestionCard';
import FreemiumPlanWrapper from 'Components/FreemiumPlanWrapper';
import InfiniteScrollComponent from 'Components/InfiniteScrollerComponent';
import PermisssionValidationWrapper from 'Components/PermissionWrapper/PermissionValidationWrapper';
import { PermissionTypes } from 'Components/PermissionWrapper/constants';

function AnnouncementContent({ isNotExtension = true }) {
    const dispatch = useDispatch();
    const {
        items,
        currentPage,
        paginationMeta,
        isLoading,
        templateType,
        searchText,
        lockedQuestionRegistryAddCount,
        unLockedQuestionRegistryAddCount
    } = useSelector((params) => params.response);

    const { companyData } = useSelector((params) => params.customization);

    const getEmptyQuestionByTemplate = () => {
        const found = QuestionRegistrySideBars.find((item) => templateType === item.templateType);
        if (found) return found.emptyMessage;
        return '';
    };

    const getQuestionByTemplate = () => {
        const found = QuestionRegistrySideBars.find((item) => templateType === item.templateType);
        return found;
    };

    let hasMore = false;
    if (paginationMeta?.totalPages && paginationMeta?.currentPage) {
        hasMore = paginationMeta?.totalPages > paginationMeta?.currentPage ? true : false;
    }

    const fetchData = () => {
        dispatch({
            type: setCurrentPage,
            currentPage: currentPage + 1
        });
    };

    // console.log('tst', companyData);
    // console.log('items', items);
    return (
        <>
            {isLoading && !items.length ? (
                <>
                    <PermisssionValidationWrapper pageName={PermissionTypes.questionRegistries}>
                        <NewQuestionCard />
                        <PremiumPlanWrapper>
                            <ImportQuestionCSVCard />
                        </PremiumPlanWrapper>
                    </PermisssionValidationWrapper>
                    <FreemiumPlanWrapper>
                        {unLockedQuestionRegistryAddCount !== 0 ? (
                            lockedQuestionRegistryAddCount === FREEMIUM_LIMITATION ? (
                                unLockedQuestionRegistryAddCount + lockedQuestionRegistryAddCount >= FREEMIUM_LIMITATION ? (
                                    <FreemiumQuestionCard />
                                ) : (
                                    ''
                                )
                            ) : (
                                ''
                            )
                        ) : (
                            ''
                        )}
                    </FreemiumPlanWrapper>
                </>
            ) : (
                <>
                    <InfiniteScrollComponent
                        dataLength={items?.length}
                        hasMore={hasMore}
                        totalItems={paginationMeta?.totalItems}
                        pullDownToRefreshThreshold={5}
                        endMessage={''}
                        loader={''}
                        scrollableTarget={'scrollable-archive'}
                        fetchData={() => {
                            if (hasMore) fetchData();
                        }}
                        loading={isLoading}
                    >
                        {items && items.length >= 1 ? (
                            items?.map((item, index) => <QuestionRegistryCard item={item} key={index + 'question'} />)
                        ) : (
                            <PremiumPlanWrapper>
                                {/* {!searchText ? getEmptyQuestionByTemplate() : 'No questions match your search.'} */}
                                {!searchText ? '' : 'No questions match your search.'}
                            </PremiumPlanWrapper>
                        )}
                        {searchText && !items.length && <>No questions match your search.</>}
                        {!searchText && getQuestionByTemplate()?.templateType === 'all' && (
                            <PermisssionValidationWrapper pageName={PermissionTypes.questionRegistries}>
                                <FreemiumPlanWrapper>{lockedQuestionRegistryAddCount < 3 ? <NewQuestionCard /> : null}</FreemiumPlanWrapper>

                                <PremiumPlanWrapper>
                                    {isNotExtension && <NewQuestionCard />}
                                    {isNotExtension && <ImportQuestionCSVCard />}
                                </PremiumPlanWrapper>
                            </PermisssionValidationWrapper>
                        )}
                        {/* {companyData?.subscription?.plan === 'Daily Subscription' && (
                            <>
                                <NewQuestionCard />
                                <ImportQuestionCSVCard />
                            </>
                        )} */}

                        <FreemiumPlanWrapper>
                            <FreemiumQuestionCard />
                            {/* {unLockedQuestionRegistryAddCount !== 0 ? (
                                lockedQuestionRegistryAddCount === FREEMIUM_LIMITATION ? (
                                    unLockedQuestionRegistryAddCount + lockedQuestionRegistryAddCount >= FREEMIUM_LIMITATION ? (
                                        <FreemiumQuestionCard />
                                    ) : (
                                        ''
                                    )
                                ) : (
                                    ''
                                )
                            ) : (
                                ''
                            )} */}
                        </FreemiumPlanWrapper>
                    </InfiniteScrollComponent>
                </>
            )}
        </>
    );
}

export default AnnouncementContent;
